// extracted by mini-css-extract-plugin
module.exports = {"Plus":"Plus--1f5Sw","FABWrapper":"FABWrapper--3JpPj"};